import { AppState } from 'store';
import {
  BankruptcyFormPlaceholders,
  EMPTY_VALUE,
} from './Bankruptcy.constants';
import { BankruptcyStates, BankruptcyResult } from './models';
import { createSelector } from 'reselect';

type LocationsType = {
  name: string;
  hobCode: string;
}[];

export const bankruptcyStatesSelector = ({
  bankruptcy: { bankruptcyStates },
}: AppState): BankruptcyStates => bankruptcyStates;

export const getCounties = (usStates: BankruptcyStates, stateHob: string) => {
  const usState = usStates.find(({ hobCode }) => hobCode === stateHob);
  return usState ? usState.counties : null;
};

export const resultSelector = ({
  bankruptcy: { result },
}: AppState): BankruptcyResult => result;

const getPlaceHolder = (text: string) => [
  {
    value: EMPTY_VALUE,
    text,
  },
];

const getOptions = (locations: LocationsType) =>
  locations
    ? locations.map(({ name: text, hobCode: value }) => ({
        value,
        text: text === 'MT' ? 'MONTANA' : text, //`${text} ${value}`,
      }))
    : [];

export const getBankruptcyStatesOptions = (
  bankruptcyStates: BankruptcyStates,
) => [
  ...getPlaceHolder(BankruptcyFormPlaceholders.STATE),
  ...getOptions(bankruptcyStates),
];

export const bankruptcyCountyOptionsSelector = createSelector(
  (state: AppState) => state.bankruptcy,
  (bankruptcy) => (stateHob: string) => {
    const placeHolder = getPlaceHolder(BankruptcyFormPlaceholders.COUNTY);
    const bankruptcyState =
      stateHob &&
      bankruptcy &&
      // @ts-ignore:
      bankruptcy.bankruptcyStates &&
      // @ts-ignore:
      bankruptcy.bankruptcyStates.find(
        (usState: any) => usState.hobCode === stateHob,
      );
    if (bankruptcyState) {
      // @ts-ignore:
      return [
        ...placeHolder,
        ...getOptions(
          // @ts-ignore:
          bankruptcyState.counties,
        ),
      ];
    }
    return getPlaceHolder(BankruptcyFormPlaceholders.COUNTY);
  },
);

export const bankruptcyDistrictSelector = createSelector(
  (state: AppState) => state.bankruptcy,
  (bankruptcy) => (stateHob: string, countyHob: string) => {
    const county =
      stateHob &&
      countyHob &&
      // @ts-ignore:
      bankruptcy.bankruptcyStates &&
      // @ts-ignore:
      bankruptcy.bankruptcyStates
        .find((usState: any) => usState.hobCode === stateHob)
        .counties.find((county: any) => county.hobCode === countyHob);
    return county && county.district ? county.district : null;
  },
);

export const minNameLength = 2;
export const requiredWarn = 'Required';

export const getCurrentSection = (formValues: any, sectionNo: string) =>
  formValues.items && formValues?.items[parseInt(sectionNo)];

export const getCurrentIndividual = (
  formValues: any,
  sectionNo: string,
  individualNo: string,
) =>
  formValues.items &&
  formValues.items[parseInt(sectionNo)] &&
  formValues.items[parseInt(sectionNo)].individuals[parseInt(individualNo)];

export const getCurrentCorporation = (
  formValues: any,
  sectionNo: string,
  corporationNo: string,
) =>
  formValues.items &&
  formValues.items[parseInt(sectionNo)] &&
  formValues.items[parseInt(sectionNo)].corporations[parseInt(corporationNo)];

export const getCurrentSectionNo = (fieldName: any) =>
  fieldName.match(/\[(.*?)\]/)[1];

// @ts-ignore:
export const getIsNamesFilled = ({ individuals, corporations }) => {
  // @ts-ignore:
  const individualsTouched = individuals.some(
    // @ts-ignore:
    ({ firstName, middleName, lastName }) =>
      // !(firstName.length < minNameLength) ||
      // !(middleName.length < minNameLength) ||
      // !(lastName.length < minNameLength),
      !!firstName || !!middleName || !!lastName,
  );
  // @ts-ignore:
  const corporationsTouched = corporations.some(
    // @ts-ignore:
    ({ corporationName }) => !!corporationName,
  );
  return individualsTouched || corporationsTouched;
};

// @ts-ignore:
export const getIsBankruptcySelected = ({ individuals, corporations }) => {
  const individualsBankruptcySelected = individuals.some(
    // @ts-ignore:
    ({ bankruptcySearch }) => bankruptcySearch,
  );
  const isCorporationsBankruptcySelected = corporations.some(
    // @ts-ignore:
    ({ bankruptcySearch }) => bankruptcySearch,
  );
  return individualsBankruptcySelected || isCorporationsBankruptcySelected;
};

// @ts-ignore:
export const getIsPatriotSelected = ({ individuals, corporations }) => {
  const individualsPatriotSelected = individuals.some(
    // @ts-ignore:
    ({ patriotSearch }) => patriotSearch,
  );
  const isCorporationsPatriotSelected = corporations.some(
    // @ts-ignore:
    ({ patriotSearch }) => patriotSearch,
  );
  return individualsPatriotSelected || isCorporationsPatriotSelected;
};
